import firebase from 'firebase'

const firebaseApp = firebase.initializeApp(
    {
        apiKey: "AIzaSyCnmzv0mH8uwcYkRZQ4xJ2ANtBYMXEp1tk",
        authDomain: "mennsenger-clone.firebaseapp.com",
        databaseURL: "https://mennsenger-clone.firebaseio.com",
        projectId: "mennsenger-clone",
        storageBucket: "mennsenger-clone.appspot.com",
        messagingSenderId: "216210510547",
        appId: "1:216210510547:web:4b539dfe3aa41bdd507a26",
        measurementId: "G-BJELF6P5WX"
      }
) ;

const db = firebaseApp.firestore()

export default db;